import { render } from "./Modifiers.vue?vue&type=template&id=762fabf0&scoped=true"
import script from "./Modifiers.vue?vue&type=script&lang=js"
export * from "./Modifiers.vue?vue&type=script&lang=js"

import "./Modifiers.vue?vue&type=style&index=0&id=762fabf0&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-762fabf0"]])

export default __exports__